<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/utils';
import {HeaderInfo, FunctionAPI, TypeContext, InterfaceType} from '@react-spectrum/docs';
import packageData from '@react-aria/utils/package.json';

---
category: Utilities
keywords: [id, props]
---

# useId

<p>{docs.exports.useId.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['useId']} />

## API

<FunctionAPI function={docs.exports.useId} links={docs.links} />

## Introduction

The `useId` hook creates an autogenerated unique `id` for an element. An `id`
from props can used instead of the autogenerated `id` when available.

## Example

```tsx
let elementId = useId();
let componentId = useId(props.id);
```
